import React from 'react';
import useRUMView from 'common-datadog/useRUMView';

import DeclinedMerchantCopy from '../DeclinedMerchantCopy';
import Screen from '../Screen';
import Disclaimers from '../Disclaimers';
import DeclinedCTA from '../DeclinedCTA';

const CustomerNotIdentified = () => {
  useRUMView('unverified');

  return (
    <Screen
      header="Your identity could not be verified."
      subheader={(
        <>
          After unsuccessful attempts to verify your identity,
          you are not eligible for financing at this time.
          {' '}
          <DeclinedMerchantCopy />
        </>
    )}
    >
      <Disclaimers textAlign="center">
        Please note that your credit score was not affected.
      </Disclaimers>
      <DeclinedCTA />
    </Screen>
  );
};

export default CustomerNotIdentified;
